module.exports = __webpack_public_path__ + "media/images/simple_secure_login-5e8bf7587fba5daed418029cedb2f9ce.png";